import React, { FunctionComponent, useContext, useEffect } from 'react';
import SummaryLinks from './SummaryLinks';
import { PostCodeContext } from '../../../../../../common/react/PostCodeContext';
import useGetPostCode from '../../../../../../common/react/useGetPostCode';
import PostcodeCheckContainer from '../../../../../../common/components/postcodeCheck/PostcodeCheckContainer';
import { useDispatch, useSelector } from 'react-redux';
import { customiseActions } from '../../../../../store/reducers/customiseReducer';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import useToggleFinCalcSpc from '../../../../../../common/react/useToggleFinCalcSpc';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import carConfigurationSelectors from '../../../../../store/selectors/carConfigurationSelectors';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';
import urlUtilities from '../../../../../../../../common/utilities/urlUtilities';
import SummaryLinksComplex from './SummaryLinksComplex';

const SummaryLinksContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { openModal } = useContext(PostCodeContext);
  const {
    platformConfig: { isFinanceEnabled, isDealerSelectionEnabled, isComplexModel },
  } = usePlatformConfig();
  const {
    configuration: { testDriveUrl, valueMyCarUrl },
  } = useWidgetContext();
  const postcode = useGetPostCode();
  const { toggleFinanceCalculatorSpc } = useToggleFinCalcSpc();
  const isCash = useSelector(currentDealSelectors.getIsCash);
  const modelTitle = useSelector(carConfigurationSelectors.getConfigurationModelTitle);
  const testDriveUrlWithModel = urlUtilities.replaceUrlParamWildcard(
    testDriveUrl,
    'model',
    stringUtilities.slugify(modelTitle),
  );

  useEffect(() => {
    dispatch(customiseActions.setPostcode(+postcode));
  }, []);

  return (
    <>
      {isDealerSelectionEnabled && <PostcodeCheckContainer />}
      {isComplexModel ? (
        <SummaryLinksComplex
          postCode={postcode}
          isDealerSelectionEnabled={isDealerSelectionEnabled}
          openPostcodeModal={openModal}
          isFinanceEnabled={isFinanceEnabled && !isCash}
          toggleFC={toggleFinanceCalculatorSpc}
          testDriveUrl={testDriveUrlWithModel}
          valueMyCarUrl={valueMyCarUrl}
        />
      ) : (
        <SummaryLinks
          postCode={postcode}
          isDealerSelectionEnabled={isDealerSelectionEnabled}
          openPostcodeModal={openModal}
          isFinanceEnabled={isFinanceEnabled && !isCash}
          toggleFC={toggleFinanceCalculatorSpc}
          testDriveUrl={testDriveUrlWithModel}
          valueMyCarUrl={valueMyCarUrl}
        />
      )}
    </>
  );
};

export default SummaryLinksContainer;
